import * as React from 'react';
import Loading from 'src/components/lib/loading/loading';
import css from './image-input.css';
import {backgroundImage} from 'src/utils/index';


type Props = {
  src: string | null | undefined;
  loading?: boolean | null | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => unknown;
  uploadHint?: React.ReactNode;
};

const ImageInput = (props: Props) => {
  const {src, loading, onChange, uploadHint} = props;

  return src ? (
    <div className={css.logoContainer}>
      {/* @ts-expect-error - TS2322 - Type '{ backgroundImage: string; } | null | undefined' is not assignable to type 'CSSProperties | undefined'. */}
      <div className={css.logoPreview} style={backgroundImage(src)}></div>
      <input className={css.logoUploadInput} type="file" onChange={onChange} />
    </div>
  ) : (
    <label>
      <div className={css.logoPreviewBlank}>
        {loading ? <Loading /> : <div>{uploadHint}</div>}
      </div>
      <input
        className={css.logoUploadInput}
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        onChange={onChange}
      />
    </label>
  );
};

export default ImageInput;
